import Geocode from "react-geocode";
import { doSingleCompanySearch } from "utils/api";

Geocode.setApiKey("AIzaSyDvXLFUSfLOZVCuK3_E3FwBn3lieP8Gt4U");

async function setCoordinates(company, addr) {
  const address = addr || `${company.co_street}, ${company.co_zip} ${company.co_city}`;
  const response = await Geocode.fromAddress(address);
  // const completeData = await doSingleCompanySearch({
  //   id: company.id,
  // });
  const { formatted_address, geometry, place_id } = response.results[0];
  const { lat, lng } = geometry.location;
  return {
    ...company,
    lat,
    lon: lng,
    formatted_address,
    place_id,
    phone: company.co_phone,
  };
}

export default setCoordinates;
